"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const WcaDelegatesIcon = createIcon({
  displayName: "WcaDelegatesIcon",
  viewBox: "0 0 40 45",
  path: (
    <>
      <path
        d="M4.44,45c-1.22,0-2.27-.44-3.14-1.32-.87-.88-1.31-1.94-1.31-3.18V9c0-1.24.44-2.3,1.31-3.18.87-.88,1.92-1.32,3.14-1.32h9.33c.52-1.35,1.33-2.44,2.44-3.26,1.11-.82,2.37-1.24,3.78-1.24s2.67.41,3.78,1.24c1.11.83,1.93,1.91,2.44,3.26h9.33c1.22,0,2.27.44,3.14,1.32.87.88,1.31,1.94,1.31,3.18v31.5c0,1.24-.44,2.3-1.31,3.18-.87.88-1.92,1.32-3.14,1.32H4.44ZM20,7.31c.48,0,.88-.16,1.19-.48.31-.32.47-.72.47-1.21s-.16-.89-.47-1.21c-.31-.32-.71-.48-1.19-.48s-.88.16-1.19.48c-.31.32-.47.72-.47,1.21s.16.89.47,1.21c.31.32.71.48,1.19.48ZM4.44,37.91c2-1.99,4.32-3.55,6.97-4.7,2.65-1.14,5.51-1.72,8.58-1.72s5.94.57,8.58,1.72c2.65,1.14,4.97,2.71,6.97,4.7V9H4.44v28.91ZM20,27c2.15,0,3.98-.77,5.5-2.31,1.52-1.54,2.28-3.39,2.28-5.57s-.76-4.03-2.28-5.57c-1.52-1.54-3.35-2.31-5.5-2.31s-3.98.77-5.5,2.31c-1.52,1.54-2.28,3.39-2.28,5.57s.76,4.03,2.28,5.57c1.52,1.54,3.35,2.31,5.5,2.31ZM8.89,40.5h22.22v-.56c-1.56-1.31-3.28-2.3-5.17-2.95-1.89-.66-3.87-.98-5.94-.98s-4.06.33-5.94.98c-1.89.66-3.61,1.64-5.17,2.95v.56ZM20,22.5c-.93,0-1.71-.33-2.36-.98-.65-.66-.97-1.45-.97-2.39s.32-1.73.97-2.39c.65-.66,1.44-.98,2.36-.98s1.71.33,2.36.98c.65.66.97,1.45.97,2.39s-.32,1.73-.97,2.39c-.65.66-1.44.98-2.36.98Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default WcaDelegatesIcon;
